import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetTicketHistorySearchFilter, updateTicketHistorySearchFilter } from './ticket-history.actions';
import { TicketHistoryFilterState } from '../ticket-history.model';
import { getTicketHistoryFilter } from './ticket-history.selectors';

@Injectable()
export class TicketHistoryFacade {
    constructor(private store: Store) {}

    updateTicketHistorySearchFilter(payload: TicketHistoryFilterState) {
        this.store.dispatch(updateTicketHistorySearchFilter({ payload }));
    }

    getTicketHistorySearchFilterState() {
        return this.store.select(getTicketHistoryFilter);
    }

    resetTicketHistorySearchFilter() {
        this.store.dispatch(resetTicketHistorySearchFilter());
    }
}
